/**
 * Created by zzy on 2019/7/23.
 */
import LayoutHome from './LayoutHome.vue'
export default LayoutHome



// WEBPACK FOOTER //
// ./src/layouts/layoutHome/index.js